import { FC, useState } from "react"
import './entregas.css'
import { Button } from "primereact/button"
import { FiCommand } from "react-icons/fi"
import { BsCollection, BsSignStopFill } from "react-icons/bs"
import { TbEditCircle, TbPointFilled } from "react-icons/tb"
import { RiEditCircleFill } from "react-icons/ri"
import { HiCollection } from "react-icons/hi"
import { EntregasTable } from "./EntregasTable/EntregasTable"

export const Entregas:FC<any> = (props):JSX.Element => {

    const { entregas, setEntregas, entregasMASTER, setEntregasMASTER, changesFlag, setChangesFlag, id, flagChangeScenario, setFlagChangeScenario, tabID }  = props

    const [openPP, setOpenPP] = useState<boolean>(false)

    const [openA, setOpenA] = useState<boolean>(false)


    return(
        <div className="entregas__wrapper">
            <div className="entregas__botonera">
                <Button severity="danger"  style={{minWidth:150}} disabled={false} label={"Parada Planta"} icon={false? <FiCommand className="loading-icon" style={{fontSize:15,marginRight:'1rem',color:'var(--primary)'}} /> :<BsSignStopFill style={{fontSize:15,marginRight:'1rem'}} />}  onClick={() => setOpenPP(true)}  outlined />
                
                <Button severity="success" style={{minWidth:150}} disabled={false} label={"Acopio"} icon={false? <FiCommand className="loading-icon" style={{fontSize:15,marginRight:'1rem',color:'var(--primary)'}} /> :<HiCollection style={{fontSize:15,marginRight:'1rem'}} />}  onClick={() => setOpenA(true)}  outlined />
                <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                    <span className="current_week-dot"></span>
                    <span style={{fontFamily:'var(--roboto-light)'}}><small>Semana actual</small></span>
                </div>
            </div>
            <div className="entregas__table">
                <EntregasTable
                    data={entregas}
                    setData={setEntregas}
                    dataMASTER={entregasMASTER}
                    setDataMASTER={setEntregasMASTER}
                    openPP={openPP}
                    setOpenPP={setOpenPP}
                    openA={openA}
                    setOpenA={setOpenA}
                    changesFlag={changesFlag}
                    setChangesFlag={setChangesFlag}
                    flagChangeScenario={flagChangeScenario}
                    setFlagChangeScenario={setFlagChangeScenario}
                    id={id}
                    tabID={tabID}
                    />
            </div>
        </div>
    )
}